export default __webpack_public_path__ + "static/media/tic.39e85fd2.png";